exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slot[data-v-b5f6ce1a]{border:2px dotted #140601;width:88px;height:88px;border-radius:10%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#140601\n}\n.slot.accepts[data-v-b5f6ce1a]{cursor:pointer\n}\n.slot>div[data-v-b5f6ce1a]{text-align:center\n}\n.slot .countdown[data-v-b5f6ce1a]{font-size:300%\n}\n.slot .simple[data-v-b5f6ce1a]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex\n}\n.slot .simple div[data-v-b5f6ce1a]{margin:4px\n}\n", ""]);

// exports
